import PropTypes from 'prop-types';
import React from 'react';
import { Modal, Row, Col } from 'antd';

import AddCustomerNurse from '../../forms/AddCustomerNurse';

const AddCustomer = ({ nurseId, visible, changeVisible }) => (
    <Modal centered width={540} footer={null} visible={visible} onOk={() => changeVisible(false)} onCancel={() => changeVisible(false)}>
        <div className="text-center">
            <h4 className="h-4">Add customer to nurse</h4>
        </div>
        <div className="mt-2">
            <Row type="flex" justify="center">
                <Col span={24} md={20}>
                    <AddCustomerNurse nurseId={nurseId} visible={visible} changeVisible={changeVisible} />
                </Col>
            </Row>
        </div>
    </Modal>
);

AddCustomer.propTypes = {
    changeVisible: PropTypes.func.isRequired,
    nurseId: PropTypes.number.isRequired,
    visible: PropTypes.bool.isRequired,
};

export default AddCustomer;
